import { Flex } from "@mantine/core";
import HeIcon from "../../../shared/ui/icons/HeIcon";
import GrayLink from "../../../shared/ui/links/GrayLink";

const TopBar = () => (
  <header className="fixed px-5 z-20 py-2.5 top-0 left-0 right-0 flex justify-between items-center border-b"
    style={{ backgroundColor: "#FFFFFF", borderColor: "#EEEEEE" }}
  >
    <HeIcon size="md" />
    <Flex gap={10} align="center">
      <GrayLink to="https://docs.hyperengage.io/getting-started/start-here" className="text-xs font-medium" style={{ color: "#5C6070" }}>Help</GrayLink>
    </Flex>
  </header>
);

export default TopBar;
